import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DigiluguReferral } from 'app/integration/document/services/digilugu-referral';

@Injectable()
export class ObservationReferralService {
  constructor(private http: HttpClient) {}

  protected baseUrl = `${environment.estnhsApi}/digilugu/observation-referrals`;

  public saveInternal(referral: DigiluguReferral): Observable<string> {
    return this.http.post(`${this.baseUrl}/internal`, referral).pipe(map((resp) => resp['serviceRequestId']));
  }
}
